import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes, Router, NavigationEnd } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { SampleModule } from 'app/main/sample/sample.module';
import { Error404Module } from 'app/main/pages/errors/404/error-404.module';

import { MenuService } from "./providers/data/menu/menu.service";
import { LoginService } from "./providers/login.provider";
import { UsersProvider } from './providers/users.provider';
import { filter, tap } from 'rxjs/operators';


const appRoutes: Routes = [   

    // Not found
    { path: '', redirectTo: 'inicio', pathMatch: 'full' },
    { path: 'inicio', loadChildren: () => import('app/main/sample/sample.module').then(m => m.SampleModule) },  
    {
        path        : 'pages',
        loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule)
    },
    {
        path        : 'apps',
        loadChildren: () => import('./main/apps/apps.module').then(m => m.AppsModule)
    },
    {
        path        : 'settings',
        loadChildren: () => import('./main/users/users.module').then(m => m.UsersModule)
    },
    {
        path        : 'searching',
        loadChildren: () => import('./main/searching/searching.module').then(m => m.SearchingModule)
    },
    {
        path        : 'management', 
        loadChildren: () => import('./main/expedient/expedient.module').then(m => m.ExpedientModule)
    },
    {
        path        : 'movement',
        loadChildren: () => import('./main/movement/movement.module').then(m => m.MovementModule)
    },
    {
        path        :'notifications-property',
        loadChildren: () => import('./main/notification-property/notification-property.module').then(m => m.NotificationPropertyModule)
    },
    { 
        path: 'notifications-property',
        loadChildren: () => import('./main/request/request.module').then(m => m.RequestModule)
    },
    {
        path : 'movement',
        loadChildren: () => import('./main/reception/reception.module').then(m => m.ReceptionModule)
    },
    {
        path : 'barcode',
        loadChildren: () => import('./main/barcode/barcode.module').then(m => m.BarcodeModule)
    },
    {
        path : 'verification-manager',
        loadChildren: () => import('./main/verification-manager/verification-manager.module').then(m => m.VerificationManagerModule)
    }
];

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),

        TranslateModule.forRoot(),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        SampleModule,
        Error404Module
    ],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{


    constructor(private _router:Router, 
                private _menuService: MenuService,
                private _userService: UsersProvider,
                private _loginservice: LoginService) {
       
       
                
        const tokenSession = localStorage.getItem('tk');

        this._router.events.pipe(
            filter((event:any)=>event.url!==undefined),
            filter((event:any)=>!(event.url==='/pages/auth/login')),
            tap(event=>{ console.log('tap routes debug', event)}),
            tap((event)=>{
                if (event.url.includes('?token=')) {
                    console.log('tap routes token debug', event);
                    let url = event.url;
                    let result = url.indexOf("=");
                    let token=url.substring(result+1);
                    sessionStorage.setItem('tk',token);
                    localStorage.setItem('tk', token);
                    //this.settingApp.setUserSetting('name', data.nk.replace('/\b\w/g', l => l.toUpperCase()));
                    //debugger
                    this._loginservice.getUser().subscribe(
                        (responseUser) => {
                            const user = responseUser['data'];
                            const typeUser = responseUser['data'].tipo;
                            sessionStorage.setItem('usr', JSON.stringify(user));
                            sessionStorage.setItem('tyem', typeUser);
                            localStorage.setItem('usr', JSON.stringify(user));
                            localStorage.setItem('tyem', typeUser);
                            sessionStorage.setItem('loginAAD','1');
                            localStorage.setItem('loginAAD','1');

                            this._menuService.setMenu(typeUser);
                            this._router.navigate(['/inicio']);
                            location.reload();
                        },
                        (error) => {
                            console.error(error);
                            sessionStorage.removeItem('tk');
                            localStorage.removeItem('tk');
                            localStorage.removeItem('loginAAD');
                            sessionStorage.removeItem('loginAAD');
                            sessionStorage.clear();
                            localStorage.clear();
                            this._router.navigate(['/pages/auth/login']);
                        }
                    );
                    return;
                }
                
                if(!(tokenSession !== null && tokenSession !== undefined)) {
                this._router.navigate(['/pages/auth/login']);
                }

         
            }),
            
       
        ).subscribe((event) => {      
                
        
     });
     




        if (tokenSession !== null && tokenSession !== undefined) {
            console.log('token debug',tokenSession)
           // const info = this.auth.getDecodedAccessToken(tokenSession).data;
            this._loginservice.getUser().subscribe(
                (responseUser) => {
                    const typeUser = responseUser['data'].tipo;
                    console.log("this._router.url",this._router.url);
                    if(typeUser === 'empleado'){
                        this._userService.getEmployeeData(responseUser['data'].empe).subscribe(
                            (response) => {
                                const typeEmployee = response['data'].trabdata.data.pues;
                                if( typeEmployee === 'Actuario'){
                                    this._menuService.setMenu(typeEmployee);
                                }
                                if( typeEmployee === 'Secretario de acuerdos'){
                                    this._menuService.setMenu(typeEmployee);
                                }
                                if (this._router.url === '/') {
                                    // this._router.navigate(['/inicio']);
                                  }
                            },
                            (error) => console.error(error)
                        );
                    }else {
                        this._menuService.setMenu(typeUser);
                        if (this._router.url === '/') {
                            // this._router.navigate(['/inicio']);
                          }
                    }
                },
                (error) => console.error(error)
            );
        }else {    
            
       
                 

        
          // this._router.navigate(['/pages/auth/login']);
        }

    }   
}
